var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHintM102102 = function SvgHintM102102(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 102,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hint_m_102_102_svg__a)",
    d: "M90 12H12v78h78z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3177FF",
    d: "M6 0h90v6H6zM6 96h90v6H6zM6 6v90H0V6zM102 6v90h-6V6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.354 78v-2.581h-2.581v-3.321h-2.845v2.425H45.23v-2.425h-2.845v3.32h-2.53V78H26.53v-2.581H24V26.527h2.53V24h14.012v2.477h3.057v5.108h2.369v4.321h2.267v4.585h5.689v-4.585h2.267v-4.321h2.369v-5.108h3.057V24h14.011v2.527h2.53V75.42h-2.53V78z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hint_m_102_102_svg__b)",
    d: "M52.447 47.812h2.426V43.81h2.369v-4.585h2.267v-4.318h2.371v-5.112h3.054v-2.476h7.376v2.53h2.53v42.253h-2.53v2.581h-6.639v-2.581H63.09V55.715H61.3v3.003h-1.582v3.213h-1.79v3.318h-2.055v3.53h-2.267v2.423h-5.054V68.78h-2.213v-3.53H44.28v-3.318h-1.79v-3.214h-1.632v-3.003h-1.791V72.1h-2.53v2.581h-6.69v-2.581h-2.53V29.848h2.53v-2.53h7.375v2.476h3.055v5.112h2.371v4.318h2.267v4.585h2.369v4.003h2.426v3.426h2.736z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hint_m_102_102_svg__a",
    x1: 11.64,
    x2: 90.358,
    y1: 11.565,
    y2: 90.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3E2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hint_m_102_102_svg__b",
    x1: 26.871,
    x2: 75.284,
    y1: 25.791,
    y2: 75.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7474E6"
  })))));
};
export default SvgHintM102102;